import { z } from 'zod';
import { emailSchema } from './auth.schema';

export const STAFF_ROLES = ['admin', 'account_manager', 'lead_specialist', 'specialist'] as const;
export const staffRoleSchema = z.enum(STAFF_ROLES);

/** Body of POST /api/admin/staff; shared so the web Add-staff form validates exactly what the API does. */
export const createStaffInputSchema = z.object({
  email: emailSchema,
  name: z.string().trim().min(1, 'Enter a name'),
  staffRole: staffRoleSchema,
  department: z.string().optional(),
  title: z.string().optional(),
  skills: z.array(z.string()).optional(),
  maxActiveTasks: z.number().int().min(1).default(5),
});

export type StaffRole = z.infer<typeof staffRoleSchema>;
export type CreateStaffInput = z.input<typeof createStaffInputSchema>;
